import { ButtonWrapper } from "ui";

interface WalletActionBtnPropTypes {
  text: string;
  onClick: () => void;
  disabled: boolean;
}

export const WalletActionBtn = ({
  text,
  onClick,
  disabled,
}: WalletActionBtnPropTypes) => {
  return (
    <ButtonWrapper
      width="100%"
      height="56px"
      marginTop="1rem"
      background="brand.primary"
      borderRadius="8px"
      color="brand.textWhite"
      fontSize="1rem"
      fontWeight="600"
      display="flex"
      justifyContent="center"
      alignItems="center"
      gap="1rem"
      type="button"
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </ButtonWrapper>
  );
};
